import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {HookClass, Hook, BaseHook, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, Observer} from 'rxjs';
import {simpleParser, ParsedMail} from 'mailparser';

@HookClass('mail')
export class MailHook extends BaseHook {

    @Hook('b31f1c83-cf99-41b1-9516-9d08fe064041')
    public parse(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return new Observable((observer: Observer<any>) => {
            simpleParser(inputArtifact.object.source, inputArtifact.object.options, (err: any, data: ParsedMail) => {

                if (err) {
                    observer.error(err);
                    observer.complete();
                    return;
                }

                const artifact = new NickProcessArtfact();
                artifact.object = data;
                artifact.kind = ArtfactKind.ANY;

                observer.next(artifact);
                observer.complete();
            });
        });
    }

}
